import { TableRow } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(2n+1)': {
      backgroundColor: '#dedede',
    },
    '&:nth-of-type(2n+2)': {
      backgroundColor: '#dedede',
    },
    '&:nth-of-type(4n+3)': {
      backgroundColor: 'white' 
    },
    '&:nth-of-type(4n+4)': {
      backgroundColor: 'white' 
    },
  }
}))(TableRow);